import React from "react"
import {
  Box,
  Container,
  GridContainer,
  Section,
  theme,
  Card,
} from "@singita/components"
import { showByTag } from "gatsby-singita-theme/src/common/utils"
import { useLanguage } from "gatsby-singita-theme/src/context/LanguageContext"
import { LocaleLink } from "gatsby-singita-theme/src/components/LocaleLink"
import { createSlug } from "../common/utils"
import ImageWrapper from "./ImageWrapper"
import GridItem from "../components/GridItem"

const styles = {
  sectionContainer: {
    bg: "midGrey",
    borderBottomWidth: "3px",
    borderColor: "lightGrey",
    borderStyle: "solid",
    borderWidth: 0,
    gridGap: `${theme.space[4]}px`,
    gridTemplateColumns: [
      "repeat(2, 1fr)",
      "repeat(2, 1fr)",
      "repeat(3, 1fr)",
      "repeat(4, 1fr)",
    ],
    width: "100%",
  },
  sectionItem: {},
}

const getActivitySlug = (activity, basePath) => {
  const headline = createSlug(activity.headline)
  if (activity.region && activity.region?.id) {
    return `/region/${createSlug(activity.region.headline)}/experience-${headline}/`
  }
  return `${basePath}/experience-${headline}/`
}

const LodgeActivitiesSection = ({ activities, title, basePath }) => {
  const lang = useLanguage()

  if (!activities?.length) return null

  return (
    <Container>
      <Section
        id="lodge-activities-section"
        headline={title}
        textContainerSx={{ width: 7 / 12 }}
      >
        <GridContainer sx={{ ...styles.sectionContainer }}>
          {showByTag(activities, "Singita").map((activity, index) => {
            return (
              <GridItem
                index={index}
                columns={[2, 2, 3, 4]}
                key={activity.id}
              >
                {lang === "en-US" ? (
                  <LocaleLink
                    data-testid={`activity-${index}`}
                    to={getActivitySlug(activity, basePath)}
                    state={{ returnPath: `${basePath}/#lodge-activities-section` }}
                  >
                    <Box
                      data-testid={`activity-${index}`}
                      sx={{ ...styles.sectionItem, cursor: "pointer" }}
                    >
                      <Card
                        variant="small"
                        isLink={true}
                        headline={activity.headline}
                        image={<ImageWrapper image={activity.images} />}
                      />
                    </Box>
                  </LocaleLink>
                ) : (
                  <Box
                    data-testid={`activity-${index}`}
                    sx={{ ...styles.sectionItem, cursor: "default" }}
                  >
                    <Card
                      variant="small"
                      isLink={false} // Set to false when not linking
                      headline={activity.headline}
                      image={<ImageWrapper image={activity.images} />}
                    />
                  </Box>
                )}
              </GridItem>
            )
          })}
        </GridContainer>
      </Section>
    </Container>
  )
}

export default LodgeActivitiesSection
